import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Table from "../../../core/common/dataTable/index";
import apiDefinitions from "../../../api/apiDefinitions";
import Accordion from "react-bootstrap/Accordion";

import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header";
import Swal from "sweetalert2";
import toast from "react-hot-toast";

import { useNavigate } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";

const ApproveBudget = () => {
  interface DecodedToken {
    exp: number;
    [key: string]: any;
  }

  const route = all_routes;
  const navigate = useNavigate();
  const [campaignList, setCampaignList] = useState([]);
  const [fieldErrors, setFieldErrors] = useState<any>({
    note: "",
  });
  const [rowData, setRowData] = useState<any>({});
  const [budget, setBudget] = useState("");
  const [note, setNote] = useState("");
  const [onClick, setOnClick] = useState(false);
  const [uploadAttendaceDocuments, setUploadAttendaceDocuments] =
    useState<any>(null);
  const [attendaceDocuments, setAttendaceDocuments] = useState<any>([]);
  const hasImageLoaded = useRef(false);
  const hasListLoaded = useRef(false);
  const [checkValidation, setCheckValidation] = useState(false);
  const [roleId, setRoleId] = useState<number | null>(null);
  const [selectedBudgetId, setSelectedBudgetId] = useState<string | null>(null);
  const [subBudgetDetails, setSubBudgetDetails] = useState<SubBudget[]>([]);

  interface ApprovedAmountChangeHandler {
    (id: number, value: string): void;
  }

  const handleApprovedAmountChange: ApprovedAmountChangeHandler = (
    id,
    value
  ) => {
    setSubBudgetDetails((prevDetails: SubBudget[]) =>
      prevDetails.map((subBudget: SubBudget) =>
        subBudget.id === id
          ? { ...subBudget, approvedAmount: Number(value) || 0 }
          : subBudget
      )
    );

    console.log("Updated subBudgetDetails:", subBudgetDetails);
  };

  const handleErrors = (error: any) => {
    setFieldErrors((previouseErrors: any) => {
      return { ...previouseErrors, ...error };
    });
  };
  const [initalErrors, setInitalErrors] = useState(false);

  const location = useLocation();
  const isLinkActive = (route: string) => {
    return location.pathname === route;
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0]; // Extract only the date in YYYY-MM-DD format
  };

  useEffect(() => {
    console.log("rowData", rowData);
  }, [rowData]);

  interface SubBudget {
    id: number;
    name: string;
    budgetId: number;
    amount: number;
    createdDate: string;
    updatedDate: string | null;
    createdBy: string | null;
    updatedBy: string | null;
    deletedBy: string | null;
    deletedDate: string | null;
    approvedAmount: number;
    financeApproveRejectNote: string;
  }

  interface Campaign {
    id: string;
    year: string;
    targetAudience: string;
    leadCount: number;
    status: string;
    startDate: string;
    endDate: string;
    subBudgets: SubBudget[];
  }

  interface Column {
    title: string;
    dataIndex: string;
    render?: (text: any, record: Campaign) => JSX.Element;
  }

  interface Activity {
    id: number;
    activityName: string;
    amount: number;
    approvedTotal: number;
    subBudgets: SubBudget[];
  }

  const columns: Column[] = [
    {
      title: "Year",
      dataIndex: "year",
    },
    {
      title: "Requested Budget (LKR)",
      dataIndex: "requestBudget",
    },
    {
      title: "Requested Date",
      dataIndex: "requestDate",
      render: (requestDate: string | null) => (
        <span>{requestDate ? formatDate(requestDate) : "N/A"}</span>
      ),
    },
    ...(roleId === 3
      ? [
          {
            title: "Marketing Approved Date",
            dataIndex: "approveRejectDate",
            render: (approveRejectDate: string | null) => (
              <span>
                {approveRejectDate ? formatDate(approveRejectDate) : "N/A"}
              </span>
            ),
          },
        ]
      : []),
    ...(roleId === 1
      ? [
          {
            title: "Finance Approved Budget (LKR)",
            dataIndex: "approvedAmount", // Use the approved total instead of requestBudget
          },
          {
            title: "Finance Approved Date",
            dataIndex: "financeApproveRejectDate",
            render: (financeApproveRejectDate: string | null) => (
              <span>
                {financeApproveRejectDate
                  ? formatDate(financeApproveRejectDate)
                  : "N/A"}
              </span>
            ),
          },
        ]
      : []),

    {
      title: "Status",
      dataIndex:
        roleId === 3 || roleId === 1 ? "approveRejectStatus" : "status",
      render: (data: any) => {
        if (roleId === 3 || roleId === 1) {
          const approveRejectStatus = data as string | null;
          const color = "warning";
          return (
            <div>
              <span className={`badge badge-pill badge-status bg-${color}`}>
                {approveRejectStatus ?? "Unknown Status"}
              </span>
            </div>
          );
        } else {
          const status = data as { id: number; name: string; color: string };
          const { name, color } = status; // Extract the status properties
          return (
            <div>
              <span className={`badge badge-pill badge-status bg-${color}`}>
                {name}
              </span>
            </div>
          );
        }
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record: Campaign) => (
        <div className="action-icons d-flex gap-2">
          {/* Eye Icon */}
          <Link
            to="#"
            className="text-info"
            title="View Details"
            data-bs-toggle="modal"
            data-bs-target="#exampleModalScrollable3"
            onClick={() => {
              getDocument(record.id);
              setRowData(record);
              setOnClick(!onClick);
              handleSetId(record.id);
            }}
          >
            <i className="ti ti-eye" style={{ fontSize: "1.8rem" }}></i>
          </Link>
        </div>
      ),
    },
  ];

  useEffect(() => {
    refreshCampaigns();
  }, [roleId]);

  const refreshCampaigns = () => {
    if (!hasListLoaded.current) {
      hasListLoaded.current = true;
      return;
    }

    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        const toastId = toast.loading("Loading Data...");

        // Determine which API to call based on roleId
        let apiCall;
        switch (decodedToken.role_id) {
          case 2:
            apiCall = apiDefinitions.getAllPendingBudgets(token, 2); // for roleId 2
            break;
          case 1:
            apiCall = apiDefinitions.getAllPendingPresident(token); // for roleId 1
            break;
          case 3:
            apiCall = apiDefinitions.getAllPendingFinance(token); // for roleId 3
            break;
          default:
            console.error("Invalid roleId", decodedToken.roleId);
            return;
        }

        apiCall.then((response: any) => {
          if (response.data.code === 200) {
            toast.dismiss(toastId);
            setCampaignList(response.data.data);
          } else {
            console.error("Failed to load campaigns", response.data.message);
            toast.dismiss(toastId);
          }
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  const getDocument = (budgetId: string) => {
    console.log("Getting documents for budget ID:", budgetId);

    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    // if (!hasImageLoaded.current) {
    //   hasImageLoaded.current = true;
    //   return;
    // }

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        const toastId = toast.loading("Loading Documents...");
        apiDefinitions
          .getJustificationByBudgetID(token, budgetId)
          .then((response: any) => {
            if (response.data.code === 200) {
              setUploadAttendaceDocuments(response.data.data);
              toast.dismiss(toastId);
              toast.success("Documents Loaded", {
                duration: 5000,
              });
            } else {
              toast.dismiss(toastId);
              toast.error("Failed to Load Data");
            }
          });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  useEffect(() => {
    if (uploadAttendaceDocuments !== null) {
      const transformedData = uploadAttendaceDocuments.map(
        (url: string, index: number) => {
          const filePath = url || "";
          const decodedFilePath = decodeURIComponent(filePath); // Decode URL-encoded characters
          const fileName = decodedFilePath.split("/").pop() || "";
          const fileExtension = filePath.split(".").pop()?.toLowerCase() || "";

          let fileType = "unknown";

          if (fileExtension === "pdf") {
            fileType = "pdf";
          } else if (fileExtension.match(/(jpg|jpeg|png|gif|bmp|svg|webp)$/)) {
            fileType = "image";
          } else if (fileExtension.match(/(doc|docx)$/)) {
            fileType = "doc";
          } else if (fileExtension.match(/(xls|xlsx)$/)) {
            fileType = "xls";
          }

          return {
            id: index, // Use index as a unique identifier
            filePath: filePath,
            fileName: fileName,
            fileType: fileType,
            fileExtension: fileExtension,
          };
        }
      );

      setAttendaceDocuments(transformedData);
    } else {
      // Handle the case where uploadAttendaceDocuments is null
      // You might want to set some default value or handle it based on your requirements
      setAttendaceDocuments([]);
    }
  }, [uploadAttendaceDocuments]);

  const handleApprove = () => {
    setCheckValidation(!checkValidation);
    let isvalid = true;

    // if (budget === "") {
    //   handleErrors({ budget: "Approved Budget Required for approval" });
    //   isvalid = false;
    // }

    // if (note === "") {
    //   handleErrors({ note: "Note Required for approve and reject" });
    //   isvalid = false;
    // }

    // if (budget === "0.00") {
    //   handleErrors({ budget: "Budget must be greater than 0" });
    //   isvalid = false;
    // }

    // if (approvedAmount < "0.00") {
    //   toast.error("Invalid Approved Budget Value");
    //   isvalid = false;
    // }

    if (fieldErrors.note === "" && isvalid) {
      const token = sessionStorage.getItem("token");

      if (!token) {
        console.error("No token found. Please log in again.");
        navigate(route.login);
        return;
      }

      handleErrors({ note: "" });

      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Approve it!",
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            const decodedToken: DecodedToken = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const payload = {
                budgetId: rowData.id,
                approvedAmount: budget,
                reason: note,
                approveRejectBy: decodedToken.serial_number,
                action: "approved",
              };

              const toastId = toast.loading("Approving Budget...");
              apiDefinitions
                .approveBudget(token, payload)
                .then((response: any) => {
                  if (response.data.code === 200) {
                    toast.dismiss(toastId);
                    toast.success("Budget Approved Successfully", {
                      duration: 5000,
                    });
                    refreshCampaigns();
                    window.location.reload();
                  } else if (response.data.code === 400) {
                    toast.dismiss(toastId);
                    toast.error(response.data.message);
                  } else {
                    toast.dismiss(toastId);
                    toast.error("Failed to Approve Budget");
                  }
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
            navigate(route.login);
          }
        }
      });
    }
  };

  const handleReject = () => {
    let isvalid = true;

    if (note === "") {
      handleErrors({ note: "Note Required for rejection" });
      isvalid = false;
    }

    if (fieldErrors.note === "" && isvalid) {
      const token = sessionStorage.getItem("token");

      if (!token) {
        console.error("No token found. Please log in again.");
        navigate(route.login);
        return;
      }

      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reject it!",
        cancelButtonText: "No, cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            const decodedToken: DecodedToken = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const payload = {
                budgetId: rowData.id,
                rejectionNote: note,
                approveRejectBy: decodedToken.serial_number,
                action: "rejected",
              };

              const toastId = toast.loading("Rejecting Budget...");
              apiDefinitions
                .approveBudget(token, payload)
                .then((response: any) => {
                  if (response.data.code === 200) {
                    toast.dismiss(toastId);
                    toast.success("Budget Rejected Successfully", {
                      duration: 5000,
                    });
                    refreshCampaigns();
                    window.location.reload();
                  } else {
                    toast.dismiss(toastId);
                    toast.error("Failed to reject Budget");
                  }
                })
                .catch((error: any) => {
                  toast.dismiss(toastId);
                  toast.error("An error occurred");
                  console.error("API call failed:", error);
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
            navigate(route.login);
          }
        }
      });
    }
  };

  useEffect(() => {
    const budgetRegex = /^\d+(\.\d{2})$/;
    if (budget === "") {
      if (initalErrors) {
        handleErrors({ budget: "Approved Budget Required for approve" });
      } else {
        setInitalErrors(true);
      }
    } else if (!budgetRegex.test(budget)) {
      handleErrors({
        budget: "Budget must be a number with exactly two decimal places",
      });
    } else {
      handleErrors({ budget: "" });
    }
  }, [budget]);

  useEffect(() => {
    if (note === "") {
      if (initalErrors) {
        handleErrors({ note: "Note Required for rejection" });
      } else {
        setInitalErrors(true);
      }
    } else {
      handleErrors({ note: "" });
    }
  }, [note]);

  useEffect(() => {
    const modalElement = document.getElementById("exampleModalScrollable3");
    if (modalElement) {
      modalElement.addEventListener("hidden.bs.modal", handleClear);
    }

    // Cleanup the event listener on component unmount
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hidden.bs.modal", handleClear);
      }
    };
  }, []);

  const handleClear = () => {
    setBudget("");
    setNote("");
    setFieldErrors({
      note: "",
    });
  };

  useEffect(() => {
    if (!hasListLoaded.current) {
      hasListLoaded.current = true;
      return;
    }
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      console.log("Decoded Token", decodedToken);

      setRoleId(decodedToken.role_id);
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  const handleSetId = (id: string) => {
    setSelectedBudgetId(id);
    console.log("Selected Budget ID:", id);
  };

  useEffect(() => {
    getDetailsById();
  }, [selectedBudgetId, onClick]);

  const getDetailsById = async (): Promise<void> => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Redirecting to login.");
      navigate("/login");
      return;
    }

    if (!selectedBudgetId) {
      return;
    }

    const loadingToastId = toast.loading("Loading Budget Details...");
    try {
      const response = await apiDefinitions.getBudgetByBudgetId(
        token,
        selectedBudgetId
      );
      const data = response.data.data[0];

      // Initialize approvedAmount as an empty string if it's 0 or null
      const updatedSubBudgets = data.budgetActivities.flatMap((activity: any) =>
        activity.subBudgets.map((subBudget: any) => ({
          ...subBudget,
          approvedAmount:
            subBudget.approvedAmount === 0 ? "" : subBudget.approvedAmount,
        }))
      );

      setSubBudgetDetails(updatedSubBudgets);
      setRowData(data);
    } catch (error) {
      console.error("Failed to fetch campaigns:", error);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  // Use useEffect to log the updated subBudgetDetails
  useEffect(() => {
    if (subBudgetDetails.length > 0) {
      const formattedData = subBudgetDetails.map((subBudget: any) => ({
        subBudgetId: subBudget.id,
        originalAmount: subBudget.amount,
        FinanceAmount: subBudget.approvedAmount || "",
      }));
      console.log(formattedData);
    }
  }, [subBudgetDetails]); // Log only when subBudgetDetails changes

  // const payload = {
  //   financeApproveRejectNote: "Your finance approval or rejection note here",
  //   approvedSubBudgets: subBudgetDetails.map(
  //     ({ id, approvedAmount }: { id: number; approvedAmount: number }) => ({
  //       id,
  //       approvedAmount: approvedAmount || 0,
  //     })
  //   ),
  // };

  // useEffect(() => {
  //   console.log("Payload", payload);
  // }, [payload]);

  interface SubBudgetDetails {
    id: number;
    name: string;
    amount: number;
    approvedAmount?: number;
  }

  const totalApprovedAmount: number = rowData.budgetActivities
    ? rowData.budgetActivities.reduce(
        (total: number, activity: any) =>
          total +
          (activity.approvedAmount || 0) +
          (activity.subBudgets?.reduce(
            (subTotal: number, subBudget: any) =>
              subTotal + (subBudget.approvedAmount || 0),
            0
          ) || 0), // Default to 0 if subBudgets is undefined
        0
      )
    : 0;

  const areAmountsEqual = (
    requestedAmount: string,
    approvedAmount: string
  ): boolean => {
    const requested = parseFloat(requestedAmount);
    const approved = parseFloat(approvedAmount);
    return requested === approved;
  };

  const handlePresidentApprove = () => {
    let isValid = true;
    console.log("President Approve");

    if (isValid) {
      const token = sessionStorage.getItem("token");

      if (!token) {
        console.error("No token found. Please log in again.");
        navigate(route.login);
        return;
      }

      Swal.fire({
        title: "Are you sure?",
        text: "Do You Want To Approve This Budget!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Approve it!",
        cancelButtonText: "No, Cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            const decodedToken: DecodedToken = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const toastId = toast.loading("Approving Budget...");
              apiDefinitions
                .approvingBudgetByPresident(token, selectedBudgetId, true)
                .then((response: any) => {
                  if (response.data.code === 200) {
                    toast.dismiss(toastId);
                    toast.success("Budget Approved Successfully", {
                      duration: 5000,
                    });
                    refreshCampaigns();
                    window.location.reload();
                  } else {
                    toast.dismiss(toastId);
                    toast.error("Failed to Approve Budget");
                  }
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
            navigate(route.login);
          }
        }
      });
    }
  };

  const handlePresidentReject = () => {
    console.log("President Reject");
    let isValid = true;

    if (isValid) {
      const token = sessionStorage.getItem("token");

      if (!token) {
        console.error("No token found. Please log in again.");
        navigate(route.login);
        return;
      }

      Swal.fire({
        title: "Are you sure?",
        text: "Do You Want To Reject This Budget!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reject it!",
        cancelButtonText: "No, Cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            const decodedToken: DecodedToken = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const toastId = toast.loading("Rejecting Budget...");
              apiDefinitions
                .approvingBudgetByPresident(token, selectedBudgetId, false)
                .then((response: any) => {
                  if (response.data.code === 200) {
                    toast.dismiss(toastId);
                    toast.success("Budget Rejected Successfully", {
                      duration: 5000,
                    });
                    refreshCampaigns();
                    window.location.reload();
                  } else {
                    toast.dismiss(toastId);
                    toast.error("Failed to Reject Budget");
                  }
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
            navigate(route.login);
          }
        }
      });
    }
  };

  const handleFinanceApprove = () => {
    let isValid = true;
    console.log("Finance Approve");

    const requestedAmount = rowData.requestBudget;

    const approvedAmount = totalApprovedAmountDisplay.toFixed(2);
    console.log("Requested Amount:", approvedAmount);

    if (!areAmountsEqual(requestedAmount, approvedAmount)) {
      if (note === "") {
        handleErrors({
          note: "Note Is Required When Requested And Approved Amounts Differ",
        });
        isValid = false;
      } else {
        handleErrors({ note: "" }); // Clear the error if note is provided
      }
    } else {
      handleErrors({ note: "" }); // Clear the error if amounts are equal
    }

    const invalidSubBudgets = subBudgetDetails
      .filter(
        (subBudget: SubBudget) =>
          !subBudget.approvedAmount || subBudget.approvedAmount <= 0
      )
      .map((subBudget: SubBudget) => subBudget.name); // Collect names of invalid sub-budgets

    if (invalidSubBudgets.length > 0) {
      const errorMessage = `Invalid Finance Values for: ${invalidSubBudgets.join(
        ", "
      )}.`;
      toast.error(errorMessage);
      isValid = false;
    }

    if (isValid) {
      const token = sessionStorage.getItem("token");

      if (!token) {
        console.error("No token found. Please log in again.");
        navigate(route.login);
        return;
      }

      Swal.fire({
        title: "Are you sure?",
        text: "Do You Want To Approve This Budget!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Approve it!",
        cancelButtonText: "No, Cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            const decodedToken: DecodedToken = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const payload = {
                financeApproveRejectNote: note,
                approvedSubBudgets: subBudgetDetails.map(
                  ({ id, approvedAmount }) => ({
                    id,
                    approvedAmount: approvedAmount || 0, // Ensures a valid number is sent
                  })
                ),
              };

              console.log("Final Payload:", payload);

              const toastId = toast.loading("Approving Budget...");
              apiDefinitions
                .approvingBudgetByFinance(
                  token,
                  selectedBudgetId,
                  true,
                  payload
                )
                .then((response: any) => {
                  if (response.data.code === 200) {
                    toast.dismiss(toastId);
                    toast.success("Budget Approved Successfully", {
                      duration: 5000,
                    });
                    refreshCampaigns();
                    window.location.reload();
                  } else {
                    toast.dismiss(toastId);
                    toast.error("Failed to Approve Budget");
                  }
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
            navigate(route.login);
          }
        }
      });
    }
  };

  const handleFinanceReject = () => {
    let isValid = true;

    if (note === "") {
      handleErrors({ note: "Note Required For Rejection" });
      isValid = false;
    }

    if (fieldErrors.note === "" && isValid) {
      const token = sessionStorage.getItem("token");

      if (!token) {
        console.error("No token found. Please log in again.");
        navigate(route.login);
        return;
      }

      Swal.fire({
        title: "Are you sure?",
        text: "Do You Want To Reject This Budget!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reject it!",
        cancelButtonText: "No, Cancel!",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          try {
            const decodedToken: DecodedToken = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const payload = {
                // isFinanceApproved: false,
                financeApproveRejectNote: note,
                approvedSubBudgets: subBudgetDetails.map(
                  ({
                    id,
                    approvedAmount,
                  }: {
                    id: number;
                    approvedAmount: number;
                  }) => ({
                    id,
                    approvedAmount: approvedAmount || 0,
                  })
                ),
              };

              const toastId = toast.loading("Rejecting Budget...");
              apiDefinitions
                .approvingBudgetByFinance(
                  token,
                  selectedBudgetId,
                  false,
                  payload
                )
                .then((response: any) => {
                  if (response.data.code === 200) {
                    toast.dismiss(toastId);
                    toast.success("Budget Rejected Successfully", {
                      duration: 5000,
                    });
                    refreshCampaigns();
                    window.location.reload();
                  } else {
                    toast.dismiss(toastId);
                    toast.error("Failed to Reject Budget");
                  }
                });
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
            navigate(route.login);
          }
        }
      });
    }
  };

  // Recalculate the total approved amount whenever subBudgetDetails changes
  const totalApprovedAmountDisplay: number = subBudgetDetails
    ? subBudgetDetails.reduce(
        (total: number, subBudget: SubBudgetDetails) =>
          total + (subBudget.approvedAmount || 0),
        0
      )
    : 0;

  useEffect(() => {
    console.log("Total Approved Amount:", totalApprovedAmountDisplay);
  }, [subBudgetDetails]);

  // State to manage approved amounts
  const [approvedAmounts, setApprovedAmounts] = useState(
    rowData.budgetActivities?.reduce((acc: any, activity: any) => {
      activity.subBudgets.forEach((subBudget: any) => {
        acc[subBudget.id] = subBudget.approvedAmount || "";
      });
      return acc;
    }, {}) || {}
  );

  // Handle changes for approved amounts
  interface ApprovedAmounts {
    [id: number]: string;
  }

  // const handleApprovedAmountChange = (id: number, value: string): void => {
  //   setApprovedAmounts((prev: ApprovedAmounts) => ({
  //     ...prev,
  //     [id]: value,
  //   }));
  // };

  const calculateTotalApprovedAmount = (activity: Activity): number => {
    return activity.subBudgets.reduce((total, subBudget) => {
      return total + (subBudget.approvedAmount || 0);
    }, 0);
  };

  const handleClose = () => {
    setBudget("");
    setNote("");
    setFieldErrors({
      note: "",
      budget: "",
    });
    setSubBudgetDetails([]); // Clear sub-budget details
    setApprovedAmounts({}); // Clear approved amounts
    setRowData({});
  };

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">
                      Annual Budget Request Approval
                    </h4>
                  </div>
                  <div className="col-8 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              <div className="campaign-tab">
                <ul className="nav">
                  <li>
                    <Link
                      to={route.ApproveBudget}
                      className={
                        isLinkActive(route.ApproveBudget) ? "active" : ""
                      }
                    >
                      Annual Budgets Requests
                    </Link>
                  </li>
                  {/* {roleId === 2 ? (
                    <li>
                      <Link
                        to={route.TopUpRequest}
                        className={
                          isLinkActive(route.TopUpRequest) ? "active" : ""
                        }
                      >
                        Top-Up Requests
                      </Link>
                    </li>
                  ) : null} */}
                </ul>
              </div>
              {/* Campaign Tab */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="row align-items-center justify-content-between">
                      {/* Search Bar aligned to the Left */}
                      <div className="col-sm-6">
                        {/* <div className="icon-form mb-3 mb-sm-0">
                          <span className="form-icon">
                            <i className="ti ti-search" />
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search Campaign"
                            onChange={(e) => setSearchKey(e.target.value)}
                          />
                        </div> */}
                      </div>

                      {/* Button aligned to the Right */}
                    </div>
                    <div className="row">
                      <div className="col-xl-12 mt-3">
                        <div className="table-responsive custom-table">
                          <Table dataSource={campaignList} columns={columns} />
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal fade"
                      id="exampleModalScrollable3"
                      tabIndex={-1}
                      aria-labelledby="exampleModalScrollable3"
                      data-bs-keyboard="false"
                      aria-hidden="true"
                    >
                      {/* Scrollable modal */}
                      <div
                        className="modal-dialog"
                        style={{ maxWidth: "900px" }}
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h4
                              className="modal-title"
                              id="staticBackdropLabel3"
                            >
                              Approve {rowData.year} Budget
                            </h4>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            />
                          </div>
                          <div className="modal-body">
                            {/* <div className="row mb-3">
                              <p>
                                <strong>Year:</strong>
                              </p>
                            </div> */}
                            <div className="row mb-3">
                              <p>
                                <strong>Requested Date:</strong>{" "}
                                {rowData.requestDate}
                              </p>
                            </div>
                            <div className="row mb-3">
                              <p>
                                <strong>
                                  {roleId === 1
                                    ? "Finance Approved Budget (LKR):"
                                    : "Requested Budget (LKR):"}
                                </strong>{" "}
                                {roleId === 1
                                  ? rowData.approvedAmount
                                  : rowData.requestBudget}
                              </p>
                            </div>
                            {roleId === 1 ? (
                              <>
                                <div className="row mb-3">
                                  <p>
                                    <strong>Finance Approval Date:</strong>{" "}
                                    {rowData.financeApproveRejectDate}
                                  </p>
                                </div>

                                <div className="row mb-3">
                                  <p>
                                    <strong>Finance Approval Note:</strong>{" "}
                                    {rowData.financeApproveRejectNote}
                                  </p>
                                </div>
                              </>
                            ) : null}

                            {roleId === 3 ? (
                              <>
                                {/* <div className="row mb-3">
                                  <p>
                                    <strong>
                                      Marketing Approval Amount (LKR):
                                    </strong>{" "}
                                    {totalApprovedAmount
                                      ? totalApprovedAmount
                                      : "N/A"}
                                  </p>
                                </div> */}
                                <div className="row mb-3">
                                  <p>
                                    <strong>Marketing Approval Date:</strong>{" "}
                                    {rowData.approveRejectDate}
                                  </p>
                                </div>
                                <div className="row mb-3">
                                  <p>
                                    <strong>Marketing Approval Note:</strong>{" "}
                                    {rowData.reason ? rowData.reason : "N/A"}
                                  </p>
                                </div>{" "}
                                {/* <div className="row mb-3">
                                  <p>
                                    <strong>New Requested Budget (LKR):</strong>{" "}
                                    {totalApprovedAmountDisplay.toFixed(2)}
                                  </p>
                                </div> */}
                              </>
                            ) : null}

                            {roleId === 3 ? (
                              <p>
                                <strong>New Approved Budget (LKR):</strong>{" "}
                                {totalApprovedAmountDisplay.toFixed(2)}
                              </p>
                            ) : null}

                            <div className="row mb-3">
                              <p>
                                <strong>Budget Activities:</strong>
                              </p>
                              <div className="table-responsive">
                                <Accordion defaultActiveKey="0">
                                  {rowData.budgetActivities &&
                                  rowData.budgetActivities.length > 0 ? (
                                    rowData.budgetActivities.map(
                                      (activity: Activity, index: number) => (
                                        <Accordion.Item
                                          eventKey={index.toString()}
                                          key={activity.id}
                                        >
                                          <Accordion.Header>
                                            {activity.activityName} (Total: LKR{" "}
                                            {roleId === 1
                                              ? activity.approvedTotal
                                              : activity.amount}
                                            )
                                          </Accordion.Header>
                                          <Accordion.Body>
                                            <table className="table table-bordered">
                                              <thead>
                                                <tr>
                                                  <th>Sub-Budget Name</th>
                                                  <th>Amount (LKR)</th>
                                                  {roleId === 3 ? (
                                                    <th>
                                                      Finance Amount (LKR)
                                                    </th>
                                                  ) : null}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {activity.subBudgets.map(
                                                  (subBudget: SubBudget) => (
                                                    <tr key={subBudget.id}>
                                                      <td>{subBudget.name}</td>
                                                      <td>
                                                        {roleId === 1
                                                          ? subBudget.approvedAmount
                                                          : subBudget.amount}
                                                      </td>
                                                      {roleId === 3 ? (
                                                        <td>
                                                          <input
                                                            type="text"
                                                            className="form-control"
                                                            value={
                                                              approvedAmounts[
                                                                subBudget.id
                                                              ]
                                                            }
                                                            onChange={(e) =>
                                                              handleApprovedAmountChange(
                                                                subBudget.id,
                                                                e.target.value
                                                              )
                                                            }
                                                            placeholder="Enter Finance Amount"
                                                          />
                                                        </td>
                                                      ) : null}
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>
                                          </Accordion.Body>
                                        </Accordion.Item>
                                      )
                                    )
                                  ) : (
                                    <p className="text-center">
                                      No Budget Activities Available
                                    </p>
                                  )}
                                </Accordion>
                              </div>
                            </div>

                            <div
                              className="card"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100%", // Ensure it takes full height of the row
                              }}
                            >
                              <div className="card-header">
                                <h5 className="card-title">
                                  Justification Documents
                                </h5>
                              </div>
                              <div
                                className="card-body"
                                style={{
                                  overflowY: "auto", // Make scrollable if content overflows
                                }}
                              >
                                <div className="row">
                                  {attendaceDocuments.map(
                                    (data: {
                                      id: React.Key | null | undefined;
                                      fileType: string;
                                      fileName: any;
                                      filePath: string | URL | undefined;
                                    }) => (
                                      <div
                                        className="col-md-6 mb-4"
                                        key={data.id}
                                      >
                                        <div className="d-flex flex-column align-items-center justify-content-center">
                                          {/* File Type Icon */}
                                          <div className="mb-3">
                                            {data.fileType === "pdf" ? (
                                              <ImageWithBasePath
                                                src="assets/img/pdf.png"
                                                className="img-fluid"
                                                alt="Logo"
                                                style={{
                                                  width: "35px",
                                                  height: "auto",
                                                }} // Adjust the width and height as needed
                                              />
                                            ) : data.fileType === "image" ? (
                                              <ImageWithBasePath
                                                src="assets/img/picture.png"
                                                className="img-fluid"
                                                alt="Logo"
                                                style={{
                                                  width: "35px",
                                                  height: "auto",
                                                }} // Adjust the width and height as needed
                                              />
                                            ) : data.fileType === "doc" ? (
                                              <ImageWithBasePath
                                                src="assets/img/doc.png"
                                                className="img-fluid"
                                                alt="Logo"
                                                style={{
                                                  width: "35px",
                                                  height: "auto",
                                                }} // Adjust the width and height as needed
                                              />
                                            ) : data.fileType === "xls" ? (
                                              <ImageWithBasePath
                                                src="assets/img/xls.png"
                                                className="img-fluid"
                                                alt="Logo"
                                                style={{
                                                  width: "35px",
                                                  height: "auto",
                                                }} // Adjust the width and height as needed
                                              />
                                            ) : null}
                                          </div>
                                          {/* File Details */}
                                          <div className="text-center">
                                            <h6
                                              className="mb-2 text-truncate"
                                              style={{
                                                maxWidth: "150px", // Adjust width as per your layout
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                              }}
                                              title={data.fileName} // Show full name on hover
                                            >
                                              {data.fileName ||
                                                "Placeholder Name"}
                                            </h6>
                                          </div>
                                          {/* Action Buttons */}
                                          <div className="d-flex justify-content-center">
                                            <a
                                              href={data.filePath?.toString()} // File URL
                                              download={data.fileName} // Download file with its name
                                              className="btn btn-outline-primary me-2 btn-sm"
                                            >
                                              Download File
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Justification document view */}
                            <div className="row mb-3"></div>
                            {/* <div className="col-md-12">
                              <label htmlFor="field-2" className="form-label">
                                Approved Budget
                              </label>
                              <div className="input-group">
                                <span
                                  className="input-group-text"
                                  id="basic-addon1"
                                >
                                  LKR
                                </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="field-2"
                                  placeholder="50000.00"
                                  aria-describedby="basic-addon1"
                                  value={budget}
                                  onChange={(e) => setBudget(e.target.value)}
                                />
                              </div>
                              {fieldErrors.budget !== "" ? (
                                <div className="text-danger">
                                  {fieldErrors.budget}
                                </div>
                              ) : null}
                            </div> */}
                            {roleId !== 1 ? (
                              <div className="col-md-12 mt-3">
                                <label htmlFor="note" className="form-label">
                                  Note
                                </label>
                                <textarea
                                  className="form-control"
                                  id="note"
                                  rows={3}
                                  placeholder="Enter your note here"
                                  value={note}
                                  onChange={(e) => setNote(e.target.value)}
                                ></textarea>
                                {fieldErrors.note !== "" && (
                                  <div className="text-danger">
                                    {fieldErrors.note}
                                  </div>
                                )}
                              </div>
                            ) : null}
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-cancel"
                              data-bs-dismiss="modal"
                              onClick={() => {
                                handleClose();
                              }}
                            >
                              Close
                            </button>
                            <>
                              {roleId === 2 ? (
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={handleReject}
                                  >
                                    Reject
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={handleApprove}
                                  >
                                    Approve
                                  </button>
                                </>
                              ) : roleId === 1 ? (
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={handlePresidentReject}
                                  >
                                    Reject
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={handlePresidentApprove}
                                  >
                                    Approve
                                  </button>
                                </>
                              ) : roleId === 3 ? (
                                <>
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={handleFinanceReject}
                                  >
                                    Reject
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-success"
                                    onClick={handleFinanceApprove}
                                  >
                                    Approve
                                  </button>
                                </>
                              ) : null}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApproveBudget;
